import {common_utils} from "../common/common_utils";
import {slots_utils} from "../../../untils/slots_utils";
import {game_304} from "./game_304";
import {slots_tool} from "./slots_tool";
import {game_100} from "./game_100";

function game_305()
{

}

game_305.odd_map  = {
  "scat":[0,0,125,250,1250],
  "P4":[0,0,50,100,1000],
  "P3":[0,0,35,100,800],
  "P2":[0,0,30,100,800],
  "P1":[0,0,20,50,300],
  "lot":[0,0,15,35,300],
  "A":[0,0,10,30,200],
  "K":[0,0,10,20,200],
  "Q":[0,0,10,15,100],
  "J":[0,0,10,15,100],
  "ten":[0,0,5,15,100],
  "nine":[0,0,5,10,100],
};

game_305.readDataValue = function(this1, data)
{
  this1.gameid = data.gameId
  this1.hasfree = true
  this1.mapList = []

  var rows = 3
  slots_utils.isFree(this1,data);
  var mapJson = JSON.parse(data.detail.spinResult)
  for (var j = 0; j < rows; j++) {
    for (var i = 0; i < 5; i++) {
      this1.mapList.push(mapJson.icons[i][j])
    }
  }

  let winValueList = [];
  let odd_map = game_305.odd_map;
  var mul = mapJson.multiplier;
  this1.wildtype = mapJson.layout
  this1.wildmul = mapJson.prize.leftmost.wild_mul
  common_utils.readDataValue(this1,data);
  this1.bonuswin = mapJson.prize.leftmost.lottery

  // 匹配下标
  let s = new slots_utils();
  this1.geValue = s.showSlotsWinLine(data.gameId, this1.mapList, 0, rows).m_dict
  this1.winlines = [];
  this1.winlines.push(s.showSlotsWinLineInfo(data.gameId, this1.mapList, 0, rows))
  // console.log(this1.geValue, "geValue")
  this1.mapIndex = []
  this1.mapListDetail = []

  if (Object.keys(this1.geValue).length != 0)
  {
    var mapIndexTmp = []
    for (var i = 0; i < Object.keys(this1.geValue).length; i++)
    {
      mapIndexTmp = Object.values(this1.geValue)[i].flat(Infinity)

      for (var j = 0; j < mapIndexTmp.length; j++)
      {
         this1.mapIndex.push(mapIndexTmp[j])
      }

      var detail = {}
      var lines = 1;
      var mapIndexFullTmp = Object.values(this1.geValue)[i]
      for (var j = 0; j < mapIndexFullTmp.length; j++) {
        lines = lines * mapIndexFullTmp[j].length
      }

      detail.key = Object.keys(this1.geValue)[i]
      detail.lines = lines
      detail.length = Object.values(this1.geValue)[i].length
      if (odd_map !=null)
      {
        detail = slots_tool.winInfo(odd_map,detail,0);
      }
      winValueList.push(detail.winValue);
      this1.mapListDetail.push(detail)
    }
  }
  let winValueTotal = slots_tool.TotalValue(winValueList,slots_tool.detailBet(data),30,data.isFree);
  if(winValueTotal !=null && mul>1 ){
    this1.winValueTotal = winValueTotal +" mul X"+this1.mul
  }else{
    this1.winValueTotal = winValueTotal;
  }
  if (this1.bonuswin > 0)
  {
    for (var i = 0; i < 5; i++)
    {
      if(mapJson.icons[i][0] == "lot")
      {
        this1.mapIndex.push(i * 5)
      }
      if(mapJson.icons[i][4] == "lot")
      {
        this1.mapIndex.push(i * 5 + 4)
      }
    }
  }
  slots_tool.drawSlotLines(this1,this1.winlines)

}
export {
  game_305
};



// WEBPACK FOOTER //
// ./src/components/slots/game_305.js